import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const login = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/api/auth/login`, {
      userName: process.env.REACT_APP_USERNAME,
      password: process.env.REACT_APP_PASSWORD,
    });

    // Extract the authToken from the response data
    const token = response.data.data.authToken;
    localStorage.setItem("authToken", token);
    return token;
  } catch (error) {
    console.error("Login failed!", error);
    throw error;
  }
};

export const getAuthToken = () => {
  return localStorage.getItem("authToken");
};
